 <template>
  <div class="t-container">
    <span>{{ title }}</span>
  </div>
</template>
<script>
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage"; // To Upload Files and Images to Storage and Get URL

import { app } from "../firebase/init.js"; // To Get Firebase App
const storage = getStorage(app);

export default {
  name: "FirebaseUploadingFile",
  data() {
    return { uploadProgress: 0 };
  },

  props: {
    onFinished: {
      type: Function,

      /**
       * @param url {url}  is downloaded url
       * @return {function|void}
       */
      default(url) {
        console.log(url);
      },
    },
    contentType: {
      type: String,
      default: "image/jpeg",
    },
    title: {
      type: String,
      default: "",
    },
    file: {
      type: String,
      default: "",
    },
    collection: {
      type: String,
      default: "Files",
    },
  },
  methods: {
    upload() {
      // Create the file metadata
      /** @type {any} */

      const file = this.file;
      const metadata = {
        contentType: this.contentType,
      };
      // Upload file and metadata to the object 'images/mountains.jpg'
      const storageRef = ref(
        storage,
        this.collection + "/" + new Date().getTime().toString() + file.name
      );
      const uploadTask = uploadBytesResumable(storageRef, file, metadata);
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.uploadProgress = progress;
        },
        (error) => {
          console.log("Error uploading: ", error);
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          getDownloadURL(uploadTask.snapshot.ref)
            .then((downloadURL) => {
              // this.addCategory(this.category);
              this.onFinished(downloadURL);
              this.uploadProgress = 0;
            })
            .then(() => {});
        }
      );
    },
  },
  created() {
    this.upload();
  },
};
</script>
<style>
.t-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.action {
  height: 40px;
  padding: 5px 10px;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  border: thin solid currentColor;
}
</style>
